import { GridColDef, GridRowSelectionModel, GridRowsProp, GridTreeNodeWithRender, GridValueGetterParams } from "@mui/x-data-grid";
import { useCallback, useContext, useEffect, useState } from "react";
import { usePermissions } from "../../../../hooks/usePermissions";
import { Menuitem } from "../../../../interfaces/Security/menu";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";
import GenericPromises from "../../../../api/GenericPromises";
import { useLocation, useNavigate } from "react-router-dom";
import { useDates } from "../../../../hooks/useDates";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../../components/Header";
import { PrimaryButton } from "../../../../theme/buttons";
import DataTable from "../../../../components/Tables/GridTableMaterialUI/DataTable";
import { Permission } from "../../../../interfaces/Security/permissions";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { useBase64 } from "../../../../hooks/useBase64";
import { Autocomplete, Box, Button, ListItemButton, Popover, TextField } from "@mui/material";
import { DialogEntity } from "../../../../components/Dialogs/DialogEntity";
import { UpdatePermission } from "./update";
import { AddPermission } from "./add";
import { AuthContext } from "../../../../context/AuthContext";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import RefreshIcon from '@mui/icons-material/Refresh';
import { BatchUpdatePermissions } from "./actions/BatchUpdatePermissions";

interface EnumInterface {
  enum_id: number,
  option_name: string,
  route: string,
  group_id: number,
  group_name: string,
}

export const TablePermission = () => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const { TimeConverter } = useDates();
  const { GenericGetResource, GenericGetResourceGeneric } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [unauthorized, setUnauthorized] = useState(true);
  const [permissionsData, setPermissionsData] = useState<GridRowsProp>([]);
  const [messageSnack, setMessageSnack] = useState("");
  const [myPreferences, setMyPreferences] = useState({});
  const { GetResourceByUrl } = usePermissions();
  const { utf8ToBase64 } = useBase64();
  const { user } = useContext(AuthContext);
  const [comboEnum, setComboEnum] = useState<EnumInterface[]>([]);
  const [openDialogUpdate, setOpenDialogUpdate] = useState(false);
  const [openDialogAdd, setOpenDialogAdd] = useState(false);
  const [openDialogUpdatePermissions, setOpenDialogUpdatePermissions] = useState(false);
  const [isLoadingAction, setIsLoadingAction] = useState(false);
  const [permissionPayload, setPermissionPayload] = useState({});
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const [permissionsIdsToUpdate, setPermissionsIdsToUpdate] = useState<GridRowSelectionModel>([]);
  const [myEnumValue, setMyEnumValue] = useState<EnumInterface>();
  const [enumLoaded, setEnumLoaded] = useState(false);
  const [anchorEl1, setAnchorEl1] = useState<HTMLButtonElement | null>(null);
  const open1 = Boolean(anchorEl1);
  const id1 = open1 ? 'simple-popover' : undefined;
  const [columns, setColumns] = useState<GridColDef<Permission>[]>([
    { field: 'resource_name', headerName: t("resources.fields.resource_name"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'resource_route', headerName: t("resources.fields.resource_route"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'create', headerName: t("permissions.fields.create"), headerClassName: 'header-grid-table', flex: 1, align: 'center', headerAlign: 'center',
      renderCell(params) {
        if (params.value) {
          return <><AddCircleOutlineIcon /></>
        }
        else {
          return <></>
        }
      },
    },
    {
      field: 'read', headerName: t("permissions.fields.read"), headerClassName: 'header-grid-table', flex: 1, align: 'center', headerAlign: 'center',
      renderCell(params) {
        if (params.value) {
          return <><AutoStoriesIcon /></>
        }
        else {
          return <></>
        }
      },
    },
    {
      field: 'update', headerName: t("permissions.fields.update"), headerClassName: 'header-grid-table', flex: 1, align: 'center', headerAlign: 'center',
      renderCell(params) {
        if (params.value) {
          return <><EditIcon /></>
        }
        else {
          return <></>
        }
      },
    },
    {
      field: 'delete', headerName: t("permissions.fields.delete"), headerClassName: 'header-grid-table', flex: 1, align: 'center', headerAlign: 'center',
      renderCell(params) {
        if (params.value) {
          return <><DeleteIcon /></>
        }
        else {
          return <></>
        }
      },
    },
    {
      field: 'creation_date', headerName: t("generic.creation_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
    { field: 'last_update_user', headerName: t("generic.last_update_user"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'last_update_date', headerName: t("generic.last_update_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
  ]);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const handleAddRow = (newRow: Permission) => {
    let myRow = {
      ...newRow,
      creation_date: new Date(),
      last_update_user: user?.user_email,
      last_update_date: new Date()
    }
    setPermissionsData((prevState) => [...permissionsData, myRow]);
  };

  const handleUpdateRow = (updateRow: Permission) => {
    if (permissionsData.length === 0) {
      return;
    }
    setPermissionsData((prevRows) => {
      const rowToUpdateIndex = permissionsData.findIndex(e => e.permissions_id === updateRow.permissions_id);

      return prevRows.map((row, index) =>
        index === rowToUpdateIndex ? updateRow : row,
      );
    });
  };

  const handleDeleteRow = (deleteRow: number) => {
    if (permissionsData.length === 0) {
      return;
    }
    setPermissionsData((prevRows) => {
      const rowToDeleteIndex = permissionsData.findIndex(e => e.permissions_id === deleteRow);
      return [
        ...permissionsData.slice(0, rowToDeleteIndex),
        ...permissionsData.slice(rowToDeleteIndex + 1),
      ];
    });
  };

  const methodUsed = useCallback(() => {
    switch (location.state.method) {
      case "add":
        {
          showSnackBar(t("generic.snackbar.add"), "success");
          break;
        }
      case "delete":
        {
          setMessageSnack(t("generic.snackbar.delete"));
          break;
        }
    }

  }, [location.state, t]);

  const loadPreferences = async () => {
    let myPreferences = await localStorage.getItem("grid-permissions");
    if (myPreferences != null) {
      setMyPreferences(JSON.parse(myPreferences));
    }
  }

  const loadColumnsOrder = async () => {
    let myOrderColumns = await localStorage.getItem("grid-permissions-columns");
    if (myOrderColumns != null) {
      let myJson = JSON.parse(myOrderColumns);
      for (let index = 0; index < myJson.length; index++) {
        const element = myJson[index];
        if (element['type'] === 'date') {
          element.headerName = t(`generic.${element.field}`);
          element.valueGetter = function (params: GridValueGetterParams<Permission, any, GridTreeNodeWithRender>) {
            return TimeConverter(params.value);
          };
        }
        if (element.field) { }
        else {
          element.headerName = t(`permissions.fields.${element.field}`);
        }
      }
      setColumns(myJson);
    }
  }

  useEffect(() => {
    GenericGetResourceGeneric("/companies", "/gcompanies").then((response) => {
      document.title = `${response.data.data[0].comercial_name} - ${t("permissions.title")}`;
    })
    if (location.state !== null && location.state.method) methodUsed();
    GenericGetResource(`/groups`)
      .then(
        (response) => {
          if (response.data.data && response.data.data.length > 0) {
            let myComboEnum = response.data.data.map((element: any) => ({
              enum_id: element.group_id,
              option_name: element.group_name,
              route: `/permissions?filter=${utf8ToBase64(`group_id=${element.group_id}`)}`,
              group_id: element.group_id,
              group_name: element.group_name,
            }));
            let myEnum = myComboEnum[0];
            setMyEnumValue(myEnum);
            setComboEnum(myComboEnum);
          }
          GetResourceByUrl(`/permissions`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              loadColumnsOrder();
              loadPreferences();
              setDataLoaded(true);
            })
            .catch((error) => {
              setMessageSnack(error.message);
              showSnackBar(error.message, 'error');
              setUnauthorized(false);
              setDataLoaded(true);
            });
        }
      ).catch((error) => {
        setMessageSnack(error.message);
        showSnackBar(error.message, 'error');
        setUnauthorized(false);
        setDataLoaded(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (myEnumValue) {
      setEnumLoaded(false);
      GenericGetResource(myEnumValue.route)
        .then((response) => {
          setPermissionsData(response.data.data);
          setEnumLoaded(true);
        }
        ).catch((error) => {
          setMessageSnack(error.message);
          showSnackBar(error.message, 'error');
          setUnauthorized(false);
          setEnumLoaded(true);
        });
    }
  }, [myEnumValue]);

  return (
    <>
      {!unauthorized && <div className='screen-container d-flex flex-column justify-content-center align-items-center'> <img alt='ERROR' style={{ height: "20rem", width: "20rem" }} src={require("../../../../assets/img/error.webp")} /> <h2>{messageSnack}</h2> </div>}
      {unauthorized && !dataLoaded && <Spinner />}
      {dataLoaded && resourceScreen?.read && <div className='screen-container'>
        <Header
          title={t("permissions.title")}
          child={
            <div className='d-flex flex-row-reverse align-items-center'>
              {/* todo: POPOVER */}
              <Button disabled={isLoadingAction} aria-describedby={id1} onClick={handleClick1}>
                <MoreHorizIcon />
              </Button>
              <Popover
                id={id1}
                open={open1}
                anchorEl={anchorEl1}
                onClose={handleClose1}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                sx={{ minWidth: 200 }}
              >
                <ListItemButton
                  onClick={() => {
                    if (permissionsIdsToUpdate.length < 1) {
                      showSnackBar(t("permissions.info.no-selected-rows"), "warning")
                    } else {
                      setOpenDialogUpdatePermissions(true);
                    }
                  }}
                  sx={{ p: 2, display: 'flex', justifyContent: 'space-between', minWidth: 200 }} disabled={false}
                >
                  {t("permissions.actions.update-permissions")}<RefreshIcon />
                </ListItemButton>
              </Popover>
              {resourceScreen?.create === true &&
                <PrimaryButton variant='outlined' onClick={() => { setOpenDialogAdd(true) }}>{t("generic.buttons.add")}</PrimaryButton>
              }
              <div className='w-25'>
                <Autocomplete
                  size="small"
                  options={comboEnum}
                  defaultValue={myEnumValue}
                  getOptionLabel={(option) => option.option_name}
                  renderOption={(props, option) => (
                    <div key={option.enum_id}>
                      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        {option.option_name}
                      </Box>
                    </div>
                  )}
                  sx={{ width: "100%", paddingRight: 1, paddingTop: 1, }}
                  isOptionEqualToValue={(option, value) => option.enum_id === value.enum_id}
                  onChange={(_, values) => {
                    setMyEnumValue(values ?? comboEnum[0]);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`${t("generic.filter")}`}
                      variant="filled"
                    />
                  )}
                  clearOnEscape={false}
                  clearIcon={null}
                />
              </div>
            </div>
          }
        />

        <div className="d-flex justify-content-center">
          {enumLoaded ?
            <DataTable
              columns={columns}
              setColumns={setColumns}
              data={permissionsData}
              entityId={"permissions_id"}
              entity={`Permissions`}
              preferences={myPreferences}
              namePreferences={"grid-permissions"}
              nameOrderColumns={"grid-permissions-columns"}
              isChildren={true}
              setOpenDialog={setOpenDialogUpdate}
              setDataRow={setPermissionPayload}
              selectRows
              onRowSelectionModelChange={(rowsIds) => { setPermissionsIdsToUpdate(rowsIds); }}
            />
            :
            <Spinner />
          }
        </div>
        <DialogEntity
          content={
            <UpdatePermission
              permissionPayload={permissionPayload}
              setOpenDialogUpdate={setOpenDialogUpdate}
              resourceScreen={resourceScreen}
              handleDeleteRow={handleDeleteRow}
              handleUpdateRow={handleUpdateRow}
            />
          }
          open={openDialogUpdate}
          setOpen={setOpenDialogUpdate}
          title={<Header title={t("permissions.title-view")} size='sm' />}
        />
        <DialogEntity
          content={
            <AddPermission
              setOpenDialogAdd={setOpenDialogAdd}
              handleAddRow={handleAddRow}
              group_id={myEnumValue?.group_id ?? 0}
            />
          }
          open={openDialogAdd}
          setOpen={setOpenDialogAdd}
          title={<Header title={t("permissions.title-view")} size='md' />}
        />
        <DialogEntity
          content={
            <BatchUpdatePermissions
              setOpenDialogUpdatePermissions={setOpenDialogUpdatePermissions}
              permissionsIdsToUpdate={permissionsIdsToUpdate}
              permissionsData={permissionsData}
              setIsLoadingAction={setIsLoadingAction}
              isLoadingAction={isLoadingAction}
              handleUpdateRow={handleUpdateRow}
            />
          }
          open={openDialogUpdatePermissions}
          setOpen={setOpenDialogUpdatePermissions}
          title={<Header title={t("permissions.actions.update-permissions")} size='md' />}
          disableEscapeKeyDown={true}
          disabledBackdropClick={true}
        />
        <SnackbarComponent />
      </div>
      }
    </>
  )
}
